import React from 'react';

import {useLayoutTypes} from 'src/hooks/dictionaries/useLayoutDictionaries';
import {UserLayout} from 'src/openapi/admin/models/UserLayout';
import {UserLayoutType} from 'src/openapi/admin/models/UserLayoutType';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Cell, Row} from '@pb/kit-component-table';

const LAYOUT_TYPE_LABELS: Record<UserLayoutType, string> = {
    [UserLayoutType.TABLE]: 'Table',
    [UserLayoutType.PIVOT_TABLE]: 'Pivot Table',
};

type Props = {
    layout: UserLayout,
    showZebra: boolean,
};

export const LayoutTableRow = ({layout, showZebra}: Props) => {
    const {getLayoutTypeByCode} = useLayoutTypes();
    const entityTypeLabel = getLayoutTypeByCode(layout.entityType)?.description || layout.entityType;

    return (
        <Row showZebra={showZebra}>
            <Cell>
                <EllipsisTextHint title={layout.name}>
                    {layout.name}
                </EllipsisTextHint>
            </Cell>
            <Cell>{entityTypeLabel}</Cell>
            <Cell>{LAYOUT_TYPE_LABELS[layout.layoutType] ?? layout.layoutType}</Cell>
            <Cell>{layout.isDefault ? 'Yes' : 'No'}</Cell>
        </Row>
    );
};
